// import { Trans } from '@lingui/react';
import React from "react";
import { Redirect } from "react-router";
import UserApi from "../../api/UserApi";
import FormComponent from "../../components/FormComponent";
import InternalLayout from "../../components/layouts/InternalLayout";
import { EditUserForm, makeUserSchema } from "./EditUser";

const CreateNewUser = FormComponent({
  displayName: "Nuevo Usuario",
  schema: makeUserSchema({
    title: "Nuevo Usuario",
    onlyEditUserData: false,
    hidePassword: true,
    hideEntityHead: false,
  }),
  uiSchema: EditUserForm.formDefinition.uiSchema,
  validate: EditUserForm.formDefinition.validate,
  submitButtons: {
    submit: { text: "Crear Usuario", className: "btn-primary2" },
  },
  async onSubmit({ formData }) {
    await UserApi.createUser(formData);
  },
  renderFormSubmitted: () => <Redirect to="/system-settings/users" />,
});

export default function() {
  return (
    <InternalLayout>
      <CreateNewUser />
    </InternalLayout>
  );
}
